module.exports = __webpack_public_path__ + "img/small-arrow.df660495.svg";